import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Icon from "./Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GentuLogo(props) {
  return /*#__PURE__*/_jsxs(Icon, _extends({}, props, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 3.34v3.02h14.28v10.29h3.36V3.34A.341.341 0 0 0 20.3 3H3.34a.331.331 0 0 0-.34.34Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.616 17.28c-5.104 0-9.256-4.136-9.256-9.256V6.99H3v1.034C3 14.986 8.654 20.64 15.616 20.64h4.7c.179 0 .34-.146.34-.34v-3.02h-5.04Z"
    })]
  }));
}
export default GentuLogo;